import styled from 'styled-components';

export const HPWrapper = styled.div`
    display: block;
    width: auto;
    height: 50px;
    text-align: center;
    color: #0D2439;
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
    cursor: pointer;
    padding: 0 20px;
    line-height: 50px;
    border: 1px solid white;
    ${p => p.borderColor && `
        border-color: ${p.borderColor};
    `}
    ${p => p.id === 'clinic-info' && `
        height: auto;
        border-radius: 0px;
        font-size: 16px;
        padding: 16px;
        padding-bottom: 8px;
        padding-top: 0;
    `}
    ${p => p.id === 'clinic-info' && p.selected && `
        border-bottom: 2px solid #29BCAB;
        color: #29BCAB;
    `}
    ${p => p.id !== 'clinic-info' && p.selected && `
        border: 1px solid #29BCAB;
    `}
`;

export const ServiceWrapper = styled.div`
    display: block;
    width: auto;
    height: 50px;
    text-align: center;
    color: #0D2439;
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
    cursor: pointer;
    padding: 0 20px;
    line-height: 50px;
    border: 1px solid white;
    ${p => p.borderColor && `
        border-color: ${p.borderColor};
    `}
    ${p => p.selected && `
        border: 1px solid #29BCAB;
    `}
`;

export const DateWrapper = styled.div`
    width: auto;
    height: 62px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 20px;
    cursor: pointer;
    padding: 0 20px;
    border-radius: 8px;
    border: 1px solid white;
    ${p => p.borderColor && `
        border-color: ${p.borderColor};
`   }
    ${p => p.selected && `
        border: 1px solid #29BCAB;
    `}
    div {
        ${p => p.webConfig.dir === 'ltr' && `
		    direction: ltr !important;
		    text-align: left;
	`}
    }
.free-time {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;
    .text {
        display: block;
        width: 100%;
        height: auto;
    }
    .date {
        color: #61788E;
        font-size: 12px;
        font-weight: 700;
        text-align: center;
    }
    .counts {
        width: 100%;
        text-align: center;
        color: #0D2439;
        font-size: 14px;
        font-weight: 500;
    }
    .no-free {
        text-align: center;
        color: #61788E;
        font-size: 14px;
        font-weight: 500;
    }
}
`;

export const Calendar = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100% !important;
    @media (max-width: 600px) {
       margin-bottom: 60px;
    }
    .border-bottom {
        width: 100%;
        height: 1px;
        background: #D4D4D4;
        margin-top: -15px;
        margin-bottom: 15px;
    }
    .no-free-time-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0px;
        margin-top: -14px;
        padding: 10px 0;
        width: 100%;
    }
    .box {
        width: 100%;
        background: #FFF;
        border-radius: 8px;
        height: auto;
        ${p => p.background && `
            background: ${p.background};
        `}
    }
    .loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 0;
        height: 50px;
    }
    span {
        display: block;
        text-align: center;
        color: #0D2439;
        font-size: 14px;
        font-weight: 500;
        padding: 16px;
        border-radius: 8px;
        cursor: pointer;
        ${p => p.spanWidth && `
            width: ${p.spanWidth};
        `}
    }
    .date-selection {
        color: #0D2439;
        font-size: 14px;
        font-weight: 700; 
        height: 22px;
        line-height: 22px;
        padding: 0 16px;
        @media (max-width: 900px) {
            display: none
        }
    }
    .no-free-times {
        color: #0D2439;
        font-size: 14px;
        font-weight: 700;
        margin: 0 !important;
        margin-top: 10px !important;
    }
    .padding-16 {
        padding: 16px !important;
    }
    .padding-0 {
        padding: 0 !important;
    }
    padding-x-30 {
        padding: 0 30px !important;
    }
    .padding-y-0 {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }
    .row-flex {
        display: flex;
        flex-direction: row;
    }
    .no-free-time {
        color: #0D2439;
        font-size: 14px;
        font-weight: 500;
        height: 50px;
        line-height: 50px;
        text-align: center;
    }
    .view-first-time-button {
        padding: 0 25px;
        line-height: 30px;
    }
    .free-times {
        height: auto;
        width: 100%;
        flex-wrap: wrap;
        gap: 2%;
        justify-content: flex-start !important;
        row-gap: 9px;
        align-items: flex-start !important;
        .item {
            width: 23.5%;
            height: 40px;
            line-height: 40px;
            border-radius: 4px;
            background: #D1FAE5;
            text-align: center;
            color: #065F46;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            @media (max-width: 360px) {
                font-size: 11px;
                font-weight: 600;
            }
        }
    }
    .button-container {
        height: 48px;
        width: 100%;
        gap: 12px;
    }
    .book-button {
        height: 48px;
        width: 80%;
        border-radius: 4px;
        ${p => !p.hiddenButton && `
            width: 100%;
        `}
        @media (max-width: 600px) {
            display: none;
        }
    }
    .close-button {
        height: 48px;
        width: 20%;
        border-radius: 4px;
        color: #61788E;
        font-size: 16px;
        font-weight: 700;
        background: white;
        border: 1px solid #61788E;
        @media (max-width: 600px) {
            display: none;
        }
    }
    .next-step-button {
        height: 48px;
        width: 100%;
        border-radius: 4px;
        cursor: pointer;
        width: 100%;
        margin-top: 10px;
    }
`